var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0261 9.5452C24.864 9.6712 22.0021 11.2868 22.0021 14.8792C22.0021 19.0344 25.6438 20.5044 25.7528 20.5408C25.736 20.6304 25.1743 22.554 23.8327 24.514C22.6365 26.2388 21.3873 27.9608 19.4868 27.9608C17.5863 27.9608 17.0972 26.8548 14.9032 26.8548C12.7652 26.8548 12.005 27.9972 10.2666 27.9972C8.52819 27.9972 7.31523 26.4012 5.92061 24.4412C4.30519 22.1396 3 18.564 3 15.1704C3 9.7272 6.53268 6.8404 10.0095 6.8404C11.8568 6.8404 13.3968 8.0556 14.5567 8.0556C15.6606 8.0556 17.3822 6.7676 19.484 6.7676C20.2805 6.7676 23.1424 6.8404 25.0261 9.5452ZM18.4862 4.4632C19.3554 3.43 19.9703 1.9964 19.9703 0.5628C19.9703 0.364 19.9535 0.1624 19.9172 0C18.503 0.0532 16.8205 0.9436 15.806 2.1224C15.0094 3.0296 14.266 4.4632 14.266 5.9164C14.266 6.1348 14.3023 6.3532 14.3191 6.4232C14.4085 6.44 14.5539 6.4596 14.6992 6.4596C15.9681 6.4596 17.5639 5.6084 18.4862 4.4632Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleLogo);
export default __webpack_public_path__ + "static/media/Apple_logo.55f5231c.svg";
export { ForwardRef as ReactComponent };